import type { FinancialFieldDefinition } from "@repo/shared/types";

// ============================================
// DEFAULT FIELD DEFINITIONS
// ============================================
// Fallbacks for a flow whose component config carries no field copies and
// whose flow has no financial situation model. QL-39 — a field is a label
// plus flags; there is no taxonomy `type` and no help text any more.

export const DEFAULT_INCOME_FIELDS: FinancialFieldDefinition[] = [
  {
    id: "employment",
    label: "Employment Income",
  },
  {
    id: "self_employment",
    label: "Self-Employment Income",
  },
  {
    id: "pension",
    label: "Pension Income",
  },
  {
    id: "investment",
    label: "Investment Income",
  },
  {
    id: "rental",
    label: "Rental Income",
  },
  {
    id: "government",
    label: "Government Benefits",
  },
  {
    id: "other_income",
    label: "Other Income",
  },
];

export const DEFAULT_ASSET_FIELDS: FinancialFieldDefinition[] = [
  {
    id: "cash_savings",
    label: "Cash & Savings",
  },
  {
    id: "money_market",
    label: "Money Market Funds",
  },
  {
    id: "stocks_funds",
    label: "Stocks & Funds",
  },
  {
    id: "bonds",
    label: "Bonds & Fixed Income",
  },
  {
    id: "pension_assets",
    label: "Pension Assets",
  },
  {
    id: "primary_residence",
    label: "Primary Residence",
  },
  {
    id: "investment_property",
    label: "Investment Property",
  },
  {
    id: "other_assets",
    label: "Other Assets",
  },
];

export const DEFAULT_LIABILITY_FIELDS: FinancialFieldDefinition[] = [
  {
    id: "mortgage",
    label: "Mortgage",
    hasMonthlyPayment: true,
  },
  {
    id: "car_loan",
    label: "Car Loan",
    hasMonthlyPayment: true,
  },
  {
    id: "other_secured",
    label: "Other Secured Debt",
    hasMonthlyPayment: true,
  },
  {
    id: "personal_loans",
    label: "Personal Loans",
    hasMonthlyPayment: true,
  },
  {
    id: "credit_cards",
    label: "Credit Card Debt",
    hasMonthlyPayment: true,
  },
  {
    id: "student_loans",
    label: "Student Loans",
    hasMonthlyPayment: true,
  },
  {
    id: "guarantees",
    label: "Guarantees Given",
  },
];

export const DEFAULT_COMMITMENT_FIELDS: FinancialFieldDefinition[] = [
  {
    id: "housing",
    label: "Housing Costs",
  },
  {
    id: "insurance",
    label: "Insurance Premiums",
  },
  {
    id: "dependent_care",
    label: "Dependent Care",
  },
  {
    id: "education",
    label: "Education Expenses",
  },
  {
    id: "alimony",
    label: "Alimony/Child Support",
  },
  {
    id: "other_fixed",
    label: "Other Fixed Costs",
  },
];
